package com.macrofocus.eflux.ui

import com.macrofocus.eflux.network.DerivedBusColumn
import com.macrofocus.eflux.network.physical.Bus
import js.objects.unsafeJso
import mui.material.Grid
import mui.material.Paper
import mui.material.Typography
import mui.material.TypographyAlign
import mui.material.styles.TypographyVariant
import mui.system.sx
import org.molap.aggregates.cube.DistributiveStatistics
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.molap.series.Series
import react.FC
import react.Props
import web.cssom.*

external interface BusSparklineColumnProps : Props {
    var bus: Bus?
    var getWidth: Double
    var dataFrame: DataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?>
    var dateTime: Series<Any?, *>
    var dateTimeStatistics: DistributiveStatistics
    var paletteType: PaletteType
    var column: DerivedBusColumn
    var masterDateTime: Long
}

val BusSparklineColumn = FC<BusSparklineColumnProps> { props ->
    val bus = props.bus
    val getWidth: Double = props.getWidth
    val dataFrame: DataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?> = props.dataFrame
    val dateTime: Series<Any?, *> = props.dateTime
    val dateTimeStatistics: DistributiveStatistics = props.dateTimeStatistics
    val paletteType: PaletteType = props.paletteType
    val column: DerivedBusColumn = props.column
    val masterDateTime = props.masterDateTime

    Grid {
        sx {
            this.display = Display.flex
            this.justifyContent = JustifyContent.spaceBetween
        }
//        style = unsafeJso {
//            display = Display.flex
//            justifyContent = JustifyContent.spaceBetween
//        }
//        this.asDynamic().justifyContent = "space-between"

        Typography {
            sx {
                minWidth = 0.px
                overflow = Overflow.hidden
            }

            variant = TypographyVariant.caption
            align = TypographyAlign.left
            +column.longName
        }

        if(bus != null) {
            Typography {
                variant = TypographyVariant.caption
                align = TypographyAlign.right
                +(column.value(bus).toString())
            }
        }
    }

    val series = dataFrame.getColumn(column) as Series<Any?, *>?
    val statistics = if (series != null) DistributiveStatistics(series) else null

    if(statistics?.mean != null) {
        Paper {
            sx = unsafeJso {
                marginTop = 2.px
                marginBottom = 2.px
                marginLeft = 4.px
                marginRight = 4.px

                backgroundColor = if (paletteType == PaletteType.dark) Color("#062333") else Color("white")

                if (statistics?.mean != null) {
                    flexShrink = number(2.0)
                    flexGrow = number(1.0)
                    flexBasis = 0.px
                }

                minHeight = 0.px

            }
            elevation = 4

            Sparkline {
                this.series = series
                this.minimum = statistics.minimum
                this.maximum = statistics.maximum
                this.getWidth = getWidth
                this.dateTime = dateTime
                this.dateTimeStatistics = dateTimeStatistics
                this.statistics = statistics
                this.paletteType = paletteType
                this.displayDateTime = masterDateTime
            }
        }
    } else {
        // Do not display categorical attribute
    }
}